import ReporteBodega from "./BodegaContainer";
export default ReporteBodega;
